import { Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GetContainersByVesselParams } from '../../../global/adapters/crpAPI';
import StepUseCase from '../../../global/components/Stepper/StepUseCase';
import { VesselSearchStep } from '../shared';

type Props = {
  isFetching?: boolean;
  resetForm: VoidFunction;
  submitForm: VoidFunction;
  values: GetContainersByVesselParams;
  onResetSearch: VoidFunction;
};

const StepperSearchContainers = ({
  isFetching,
  resetForm,
  submitForm,
  values,
  onResetSearch,
}: Props) => {
  const { t } = useTranslation(['changeVoyage', 'common', 'useCase']);

  const resetFormAndValues = () => {
    resetForm();
    onResetSearch();
  };

  const { vesselName, stayNumber, imoNumber, equipmentNumber, billOfLadingNumber } = values;

  const searchAvailable =
    vesselName !== '' ||
    imoNumber !== '' ||
    equipmentNumber !== '' ||
    billOfLadingNumber !== '' ||
    stayNumber !== '';

  return (
    <Paper sx={{ p: 2, minWidth: 0, overflow: 'visible' }}>
      <StepUseCase
        activeStep={0}
        steps={[
          {
            stepTitle: t('common:general.search'),
            stepFlavorText: t('useCase:containers.containerSearchFlavorText'),
            backCallBack: resetFormAndValues,
            backCustomText: t('common:general.reset'),
            nextCallBack: submitForm,
            nextCustomText: isFetching
              ? t('useCase:containers.loadingContainers')
              : t('useCase:containers.searchContainers'),
            nextIsLoading: isFetching,
            content: (
              <VesselSearchStep
                showIsArchived={true}
                customHelperText={t('validation:atLeastNonStatusField')}
                withReleaseRightStatus
              />
            ),
            disableNext: !searchAvailable,
          },
        ]}
      />
    </Paper>
  );
};
export default StepperSearchContainers;
